import { openBlock as l, createElementBlock as o, createElementVNode as t } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function n(c, e) {
  return l(), o("svg", r, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M9.993 3.333A6.663 6.663 0 0 0 3.333 10c0 3.68 2.98 6.667 6.66 6.667A6.67 6.67 0 0 0 16.667 10a6.67 6.67 0 0 0-6.674-6.667m.007 12A5.33 5.33 0 0 1 4.667 10 5.33 5.33 0 0 1 10 4.667 5.33 5.33 0 0 1 15.333 10 5.33 5.33 0 0 1 10 15.333"
    }, null, -1),
    t("path", {
      fill: "currentColor",
      d: "M10.333 6.667h-1v4l3.5 2.1.5-.82-3-1.78z"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
